import {
  MdClose,
  MdPeople,
  MdRestaurantMenu,
  MdCategory,
  MdCurrencyRupee,
  MdAccessTime,
} from "react-icons/md";

import "./CateringDetailsModal.css";
import getImageUrl from "../../../../../../utils/imageUrl";
function CateringDetailsModal({
  isOpen,
  packageData,
  onClose,
}) {
  if (!isOpen || !packageData) return null;

  return (
    <div className="catering-modal-overlay">

      <div className="catering-details-modal">

        <button
          className="close-btn"
          onClick={onClose}
        >
          <MdClose />
        </button>

        {packageData.image &&
  packageData.image.trim() !== "" && (
    <img
      src={getImageUrl(
        `/uploads/${packageData.image}`
      )}
      alt={packageData.packageName}
      onError={(e) => {
        e.currentTarget.style.display = "none";
      }}
    />

)}

        <div className="details-content">

          <h2>{packageData.packageName}</h2>

          <p>{packageData.description}</p>

          <div className="details-grid">

            <div>
              <MdCategory />
              <span>{packageData.category}</span>
            </div>

            <div>
              <MdRestaurantMenu />
              <span>{packageData.foodType}</span>
            </div>

            <div>
              <MdCurrencyRupee />
              <span>
                ₹{packageData.pricePerPlate}/Plate
              </span>
            </div>

            <div>
              <MdPeople />
              <span>
                {packageData.minimumGuests} -{" "}
                {packageData.maximumGuests} Guests
              </span>
            </div>

            <div>
              <MdAccessTime />
              <span>
                {packageData.preparationTime} mins
              </span>
            </div>

          </div>

          <h3>Menu</h3>

          <ul className="menu-list">

            {packageData.menuItems?.map((item, index) => (
              <li key={index}>{item}</li>
            ))}

          </ul>

        </div>

      </div>

    </div>
  );
}

export default CateringDetailsModal;